import React from "react";
import logo from "../assets/images/Pillar-logo-plain.png"
import "./navbar.css"
import { BsBriefcase, BsDownload } from "react-icons/bs";
import { Link } from 'react-router-dom';
import Downloads from "./downloads/Downloads";
import Careers from "./careers/Careers";


export default function Navbar(props) {
    return (
        <div className="header">
            <div className="navbar-wrapper">
                <img src={logo} alt="Pillar Logo" className="nav-logo" />
                <div className="nav-links">
                    <ul className="nav">
                        <li className="dropdown-container nav-list-item">
                            <BsBriefcase className="icons" />
                            <Careers />
                        </li>
                            <li className="dropdown-list-wrapper">
                            <BsDownload className="icons" />
                            <Downloads />
                        </li>
                    </ul>
                    <ul className="nav nav-lower-row">
                    <li className="nav-list-item"><Link to="/">Home</Link></li>
                    <li className="nav-list-item"><Link to="/staffing">Staffing</Link></li>
                    <li className="nav-list-item"><Link to="/consulting">Consulting</Link></li>
                    <li  className="nav-list-item" onClick={props.handleClick}><a>Contact</a></li>
                    </ul>
                </div>
            </div>
        </div>
    )
}